export default () => {
  $('.data-video-id').each(function () {
    const currentVideoId = $(this).data('video-id')
    $(this).html(`
      <iframe src="${currentVideoId}" style="border: none; position: absolute; top: 0; left: 0; height: 100%; width: 100%;"
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="allowfullscreen"></iframe>
    `)
  })
}
